export default function () {
  const moduleName = 'transferValue'
  Array.from(document.querySelectorAll('.js-transfer-value')).forEach((wrapper) => {
    if (wrapper.dataset[moduleName + 'Init'] === 'true') return
    wrapper.dataset[moduleName + 'Init'] = 'true'

    wrapper.addEventListener('click', (event) => {
      event.preventDefault()

      const element = document.querySelector('#' + wrapper.dataset.transferId)

      if (element) {
        element.value = wrapper.dataset.transferValue
      }
    })
  })
};
